<template>
  <div
    v-bind:style="showModalDates ? {display: 'block'} : {display: 'none'}"
    class="modal"
    id="infoModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="display: none;"
  >
    <div class="modal-dialog modal-info" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4
            class="modal-title"
          >Modificación de fechas :: {{portage.ship_name}}</h4>
          <button
            @click="close"
            class="close"
            type="button"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <b-form>
            <b-row class="form-group">
              <b-col sm="12">
                <label for>{{serviceSelected === 'EXPO' ? 'STACKING' : 'TD'}}</label>
              </b-col>
              <b-col sm="12">
                <date-picker
                  v-if="serviceSelected === 'IMPO'"
                  v-model="td"
                  lang="es"
                  type="datetime"
                  required
                  format="DD/MM/YYYY HH:mm"
                  :time-picker-options="{ start: '00:00', step: '01:00', end: '23:00' }"
                ></date-picker>
                <date-picker
                  v-else
                  v-model="stacking"
                  lang="es"
                  type="datetime"
                  required
                  format="DD/MM/YYYY HH:mm"
                  :time-picker-options="{ start: '00:00', step: '01:00', end: '23:00' }"
                ></date-picker>
              </b-col>
            </b-row>
            <b-row class="form-group">
              <b-col sm="12">
                <label for>{{serviceSelected === 'EXPO' ? 'CUTOFF' : 'CIERRE'}}</label>
              </b-col>
              <b-col sm="12">
                <date-picker
                  v-model="cutoff"
                  lang="es"
                  type="datetime"
                  required
                  format="DD/MM/YYYY HH:mm"
                  :time-picker-options="{ start: '00:00', step: '01:00', end: '23:00' }"
                ></date-picker>
              </b-col>
            </b-row>
          </b-form>
        </div>
        <div class="modal-footer">
          <button @click="save()" type="button" class="btn btn-primary">Guardar</button>
          <button @click="close" type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";
import moment from "moment";

export default {
  name: "ModalDates",
  props: [
    "showModalDates",
    "serviceSelected",
    "portage",
    "updateDates"
  ],
  data() {
    return {
      td: this.portage.td,
      stacking: this.portage.stacking,
      cutoff: this.portage.cutoff
    };
  },
  methods: {
    save() {
      const {
        updateDates
      } = this;

      let data = {
        cutoff: moment(this.cutoff).format('YYYY-MM-DD HH:mm:00')
      }
      if(this.serviceSelected === constants.EXPORTACION){
        data.stacking = moment(this.stacking).format('YYYY-MM-DD HH:mm:00')
      } else {
        data.td = moment(this.td).format('YYYY-MM-DD HH:mm:00')
      }

      updateDates(data);
      this.close();
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>
